export class Step1 {
    constructor() {}

    intitule = 'stepper.form.dive_in.step1';
    getmiseenconcurrence = 'form.dive_in.getmiseenconcurrence';

}
